// extracted by mini-css-extract-plugin
export default {"bottom":"IgnoreResponsivePageBodyPadding_bottom__s5PRn","top":"IgnoreResponsivePageBodyPadding_top__U7CP8"};